module.exports = __webpack_public_path__ + "assets/img/driver-btn-fba9e627.png";